module.exports = __webpack_public_path__ + "static/media/landing-mobile-2x.29e4b923.jpg";